import { z } from 'zod';
import { messages } from '@/config/messages';
import { fileSchema } from './common-rules';
import { Order } from '@/types';
import { Label } from 'recharts';

// form zod validation schema
export const SystemSettingFormSchema = z.object(
  {
    id: z.string().optional(),
    name: z.string().nonempty({ message: messages.nameIsRequired }),
    subTitle: z.string().nonempty({ message: messages.subTitleIsRequired }),
    heroDescription: z.string().nonempty({ message: messages.heroDescriptionIsRequired }),
    servicesTitle: z.string().nonempty({ message: messages.servicesTitleIsRequired }),
    servicesDescription: z.string().nonempty({ message: messages.servicesDescriptionIsRequired }),
    aboutTitle: z.string().nonempty({ message: messages.aboutTitleIsRequired }),
    aboutDescription: z.string().nonempty({ message: messages.aboutDescriptionIsRequired }),
    contactOne: z.string().nonempty({ message: messages.contactOneIsRequired }),
    whatsApp: z.string().nonempty({ message: messages.whatsAppIsRequired }),
    address: z.string().nonempty({ message: messages.addressIsRequired }),
    email: z.string().email({ message: messages.emailIsRequired }),
    contactTwo: z.string().optional(),
    contactThree: z.string().optional(),
    facebook: z.string().optional(),
    twitter: z.string().optional(),
    instagram: z.string().optional(),
    linkedIn: z.string().optional(),
    youTube: z.string().optional(),
    description: z.string().nonempty({ message: messages.descriptionIsRequired }),
    image: z.string().optional(),
    icon: z.string().optional()
  },
);

// generate form types from zod validation schema
export type CreateSystemSettingInput = z.infer<typeof SystemSettingFormSchema>;
